import { useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useTheme, Box, Typography } from "@mui/material";
import { useAuth } from "@/hooks/auth";

export default function SignOut() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { currentUser, logout } = useAuth();


  const protectedRoutePrefixes = ['/freelancer', '/admin', '/stakeholder', '/student'];
  const referrer = document.referrer;
  const cameFromProtectedRoute = protectedRoutePrefixes.some(prefix => 
    referrer.includes(prefix)
  ) || location.state?.fromProtectedRoute;


  if (!cameFromProtectedRoute) {
    return <Navigate to="/not-found" replace />;
  }

  useEffect(() => {
    if (currentUser) {
      logout();
    }
    const timer = setTimeout(() => {
      navigate("/login");
    }, 800);

    return () => clearTimeout(timer);
  }, [navigate, currentUser, logout]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2),
        textAlign: "center",
      }}
    >
      <Typography variant="h4" gutterBottom>
        You have been signed out.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Redirecting to login...
      </Typography>
    </Box>
  );
};
